module.exports = __webpack_public_path__ + "img/Wp_2011.0f99c8d3.png";